export default {
  construction: 'In construction.',
  menu: {
    item1: 'Conference',
    item2: 'Venue',
    item3: 'Submissions',
    item4: 'Registrations',
    item5: 'Dates',
    item6: 'News',
    items1: [
      { title: 'Presentation' },
      { title: 'Organization' },
      { title: 'Schedule' },
      { title: 'Guest Speakers' },
      { title: 'Scientific Commission' },
      { title: 'Proceedings' },
      { title: 'Certificados' },
    ],
    items3: [
      { title: 'Themes and topics' },
      { title: 'Abstracts submission' },
      { title: 'Accepted abstracts' },
      { title: 'Papers submission' },
      { title: 'Accepted papers' },
      { title: 'Presentation instructions' },
    ],
  },
  content: {
    items1: [
      {
        text: 'PLURIS represents the continuity of the partnership between researchers from Brazil and'
        + ' Portugal since 2005. It is a multidisciplinary technical-scientific association, bringing together'
        + ' professionals who work mainly on the following topics: Environment and Energy; Innovative'
        + ' and Smart Cities; Mobility and Transport; and Regional and Urban Planning. <br><br>'
        + 'Preceded by PLURIS 2018, held in Coimbra (Portugal), the biennial Congress has its ninth'
        + ' edition to be held in Brazil and was planned to be hosted in the city of Águas de Lindóia, on'
        + ' April 07, 08 and 09, 2021. However, due to the effects of the pandemic caused by COVID-'
        + '19, the conference will be digital. The event is open to different participant profiles:'
        + ' researchers, students and professionals who work on the topics related to the conference.'
        + ' Thus, this edition in 2021 should reinforce and improve the contacts built in previous editions'
        + ' and integrate new participants whose academic and professional work are related to the'
        + ' thematic areas of the conference. <br><br>'
        + 'The PLURIS 2021 theme, <i>"Small cities, big challenges, multiple opportunities"</i>, seeks to'
        + ' shed light on the vast majority of cities in the Brazilian and Portuguese territories. The'
        + ' urbanization process is known to be often associated with large urban centers, but this'
        + ' process also occurs in small demographic cities. Consequently, these cities also deserve'
        + ' attention in relation to the planning of areas of housing, sanitation, education, health,'
        + ' mobility, safety, environmental protection and conservation of historical and cultural heritage,'
        + ' as these aspects interfere with the quality of life of their inhabitants.<br><br>'
        + 'The current challenge for small cities is to provide a sustainable urban, environmental,'
        + ' economic and cultural development. Due to their scale, smaller territorial extension and'
        + ' population, these municipalities are different in relation to other cities regarding the'
        + ' implementation of more effective planning actions, which can guarantee the best quality of'
        + ' life for the population.<br><br>'
        + 'We look forward to meeting you at PLURIS 2021 digital.<br><br>'
        + 'Greetings from the Local Organization,<br><br>'
        + 'Renata Cardoso Magagnin<br>'
        + 'Maria Solange Gurgel de Castro Fontes<br>'
        + 'Gustavo Garcia Manzato<br>'
        + 'São Paulo State University (UNESP)',
      },
      {
        text: '<b>PLURIS PERMANENT COORDINATION</b><br><br>'
        + '<b>Scientific Coordinators</b><br><br>'
        + 'PROF. DR. ANTÔNIO NÉLSON RODRIGUES DA SILVA<br>'
        + 'University of São Paulo - BR<br>'
        + 'anelson@sc.usp.br<br><br>'
        + 'PROF. DR. RUI ANTÓNIO RODRIGUES RAMOS<br>'
        + 'University of Minho - PT<br>'
        + 'rui.ramos@civil.uminho.pt<br><br>'
        + 'PROFA. DRA. LÉA CRISTINA LUCAS DE SOUZA<br>'
        + 'Federal University of São Carlos - BR<br>'
        + 'leacrist@ufscar.br<br><br>'
        + '<b>TI Coordinator</b><br><br>'
        + 'PROF. DR. DANIEL SOUTO RODRIGUES<br>'
        + 'University of Minho - PT<br>'
        + 'dsr@civil.uminho.pt<br><br><br>'
        + '<b>LOCAL COORDINATION AND ORGANIZATION</b><br><br>'
        + 'Renata Cardoso Magagnin<br>'
        + 'Maria Solange Gurgel de Castro Fontes<br>'
        + 'Gustavo Garcia Manzato<br>'
        + 'São Paulo State University (UNESP)<br>',
        title1: 'PERMANENT COORDINATION',
        title2: 'LOCAL COORDINATION AND ORGANIZATION',
        contentContinuation: '<br><br><b>VISUAL IDENTITY DEVELOPMENT - PLURIS 2020/2021</b><br><br>'
        + '<b>INKY DESIGN</b><br>'
        + 'Marina de Araujo (student - creation)<br>'
        + 'Natália Schiavon (student - creation)<br>'
        + 'Profa. Dra. Cássia Carrara Domiciano (Coordination)<br>'
        + 'Profa. Dra. Fernanda Henriques (Coordination)<br><br><br>'
        + '<b>WEBSITE PLURIS 2020/2021 DEVELOPMENT</b><br><br>'
        + 'Bianca Dias Barbosa (student)<br><br><br>'
        + '<b>DIGITAL PLATFORM SUPPORT</b><br><br>'
        + 'Cíntia Machado de Oliveira<br>',
      },
      {
        wednesday: 'WEDNESDAY',
        thursday: 'THURSDAY',
        friday: 'FRIDAY',
        morning: 'M<br>O<br>R<br>N<br>I<br>N<br>G',
        afternoon: 'A<br>F<br>T<br>E<br>R<br>N<br>O<br>O<br>N',
        evening: 'E<br>V<br>E<br>N<br>I<br>N<br>G',
        startingat17h: 'Starting at 17h',
        schedule: [
          'Registration',
          'Thematic Sessions <br>Poster session',
          'Thematic Sessions',
          '<b>Workshop 1 <br> or <br> Workshop 2</b>',
          'Opening session<br>',
          'Coffee break',
          'Conference<br>',
          'Lunch break',
          'Thematic Sessions <br>Poster session',
          'Closing session',
          'Closing coffee beak',
          'Welcome cocktail',
          'Congress Dinner',
        ],
        text: 'Click <a href="/programacao.pdf" download>here</a> to download the program in PDF.',
      },
      {
        text: '',
      },
      {
        text: 'Ademir Paceli Barbassa<br>'
        + 'Adriana Capretz<br>'
        + 'Alan Ricardo da Silva<br>'
        + 'Alessandra Rodrigues Prata-Shimomura<br>'
        + 'Alexandre Marques<br>'
        + 'Ana Bastos<br>'
        + 'Ana Elisabete de Almeida Medeiros<br>'
        + 'Ana Maria Guerra Seráfico Pinheiro<br>'
        + 'Ana Paula Camargo Larocca<br>'
        + 'Anabela Salgueiro Narciso Ribeiro<br>'
        + 'Andrea Ribeiro<br>'
        + 'Anna Silvia Palcheco Peixoto<br>'
        + 'António Armando Lima Sampaio Duarte<br>'
        + 'António José Pais Antunes<br>'
        + 'António Manuel de Sousa Baltazar Mortal<br>'
        + 'Antonio Nelson Rodrigues da Silva<br>'
        + 'Arminda Maria Marques Almeida<br>'
        + 'Ary Ferreira da Silva<br>'
        + 'Augusto Brasil<br>'
        + 'Barbara Stolte Bezerra<br>'
        + 'Bernardo Arantes do Nascimento Teixeira<br>'
        + 'Bianca Carla Dantas de Araújo<br>'
        + 'Bruno Bertoncini<br>'
        + 'Caio Frederico E silva<br>'
        + 'Camila Mayumi Nakata-Osaki<br>'
        + 'Carlos Alberto Bragança dos Santos<br>'
        + 'Carmen Velásquez Marea<br>'
        + 'Cira Souza Pitombo<br>'
        + 'Claudia Cotrim Pezzuto<br>'
        + 'Cláudia Mariz de Lyra Barroso Krause<br>'
        + 'Daniel Souto Rodrigues<br>'
        + 'Denise Balestrero Menezes<br>'
        + 'Diogenes Cortijo Costa<br>'
        + 'Douglas Barreto<br>'
        + 'Eduardo Oliveira<br>'
        + 'Eliane Viviani<br>'
        + 'Elio Trusiani<br>'
        + 'Erich Kellner<br>'
        + 'Érico Masiero<br>'
        + 'Erika Cristine Kneib<br>'
        + 'Fabiana Serra de Arruda<br>'
        + 'Fabiola Aguiar<br>'
        + 'Fernando Cavalcanti<br>'
        + 'Flávia Araújo<br>'
        + 'Francisco Manuel Camarinhas Serdoura<br>'
        + 'Fred Rodrigues<br>'
        + 'Frederico Yuri Hanai<br>'
        + 'Geovany Jessé Alexandre da Silva<br>'
        + 'Gianna Melo Barbirato<br>'
        + 'Gustavo Garcia Manzato<br>'
        + 'Ilce Marilia Dantas Pinto<br>'
        + 'Ilza Machado Kaiser<br>'
        + 'Irineu da Silva<br>'
        + 'Jefferson Oliveira Goulart<br>'
        + 'João Carlos<br>'
        + 'João Roberto Gomes de Faria<br>'
        + 'José Alberto Tostes<br>'
        + 'José Aparecido Sorratini<br>'
        + 'José da Costa Marques Neto<br>'
        + 'José Leomar Fernandes Júnior<br>'
        + 'José Manuel Ferreira da Silva<br>'
        + 'Josiane Palma Lima<br>'
        + 'Júlia Maria Brandão Barbosa Lourenço<br>'
        + 'Juliana Michaello<br>'
        + 'Karin Regina de Castro Marins<br>'
        + 'Léa Cristina Lucas de Souza<br>'
        + 'Leandro Cardoso<br>'
        + 'Lenise Grando Goldner<br>'
        + 'Leonardo Herszon Meira<br>'
        + 'Leonardo Marques Monteiro<br>'
        + 'Licinio da Silva Portugal<br>'
        + 'Lígia Conceição<br>'
        + 'Lindon Fonseca Matias<br>'
        + 'Lúcia Hidaka<br>'
        + 'Luzenira Alves Brasileiro<br>'
        + 'Magaly Romão<br>'
        + 'Maisa Tobias<br>'
        + 'Manuela Fernanda Gomes Moreira da Silva<br>'
        + 'Marcio Dagosto<br>'
        + 'Marcos Thadeu Queiroz Magalhães<br>'
        + 'María José Prados<br>'
        + 'Maria Manuela de Oliveira Guedes de Almeida<br>'
        + 'Maria Manuela Rosa<br>'
        + 'Maria Manuela Santos Natário<br>'
        + 'Maria Solange Gurgel de Castro Fontes<br>'
        + 'Maria Teresa Françoso<br>'
        + 'Mario Angelo Nunes de Azevedo Filho<br>'
        + 'Marta Cristina de Jesus Albuquerque Nogueira<br>'
        + 'Mateus Araujo e Silva<br>'
        + 'Mauro Normando Macêdo Barros Filho<br>'
        + 'Nair Cristina Margarido Brondino<br>'
        + 'Nívea Adriana Dias Pons<br>'
        + 'Norma Regina Truppel Constantino<br>'
        + 'Nuno Pinto<br>'
        + 'Orlando Strambi<br>'
        + 'Oswaldo Cavalcanti da Costa Lima Neto<br>'
        + 'Pablo Brilhante de Sousa<br>'
        + 'Paula Remoaldo<br>'
        + 'Paulo César Lima Segantine<br>'
        + 'Paulo Jorge Gomes Ribeiro<br>'
        + 'Paulo Roberto Masseran<br>'
        + 'Renata Cardoso Magagnin<br>'
        + 'Renato da Silva Lima<br>'
        + 'Ricardo Trevisan<br>'
        + 'Rodrigo Nóbrega<br>'
        + 'Rômulo José da Costa Ribeiro<br>'
        + 'Ronaldo Balassiano<br>'
        + 'Rui António Rodrigues Ramos<br>'
        + 'Rui Gama Fernandes<br>'
        + 'Samir Hernandes Tenorio Gomes<br>'
        + 'Sandra Regina Mota Silva<br>'
        + 'Sérgio Gomes<br>'
        + 'Sérgio Luiz Garavelli<br>'
        + 'Sidnei Pereira da Silva<br>'
        + 'Simone Becker Lopes<br>'
        + 'Teresa Cristina de Almeida Faria<br>'
        + 'Vasco Barbosa<br>'
        + 'Waldemir Rodrigues Costa Júnior<br>'
        + 'Waldir José Gaspar<br>'
        + 'Wellington Mary<br>',
      },
      {
        text: 'Click <a href="/anais.pdf" download>here</a> to access the final version of the Proceedings.',
      },
      {
        text: 'Clique <a href="/certificados.pdf" download>aqui</a> para acessar os certificados do PLURIS 2021.',
      },
    ],
    items2: [
      {
        text: '<b>Digital Conference</b><br><br>'
        + 'PLURIS 2021 will be held in digital format.<br><br>'
        + 'Click <a href="https://plurisdigital.ciente.live/login/" target="_blank">here</a> to access the platform of the conference activities.',
      },
    ],
    items3: [
      {
        text: '<b>THEMES</b><br><br>'
        + '<b>1. ENVIRONMENT AND ENERGY</b> <br>'
        + '<b>2. INNOVATIVE AND INTELLIGENT CITIES</b> <br>'
        + '<b>3. MOBILITY AND TRANSPORT</b> <br>'
        + '<b>4. REGIONAL AND URBAN PLANNING</b> <br><br>'
        + '<b>TOPICS RELATED TO THEMES</b> <br><br>'
        + '01 Urban accessibility and mobility<br>'
        + '02 Genetic Algorithms<br>'
        + '03 Built environment space<br>'
        + '04 Spatial Analysis<br>'
        + '05 Environmental aspects of transport<br>'
        + '06 Cellular automata<br>'
        + '07 Digital cities and regions<br>'
        + '08 Climate and urban planning<br>'
        + '09 Environmental comfort in urban spaces<br>'
        + '10 Urban ecology<br>'
        + '11 Education and technology transfer<br>'
        + '12 Energy and urban planning<br>'
        + '13 Ergodesign and usability in urban spaces<br>'
        + '14 Spatial statistics<br>'
        + '15 Geomatics applied to land management<br>'
        + '16 Environmental management<br>'
        + '17 Infrastructure management<br>'
        + '18 Inclusiveness of urban spaces<br>'
        + '19 Transport / land use integration<br>'
        + '20 Logistics<br>'
        + '21 Computer aided planning<br>'
        + '22 Planning and management of land use<br>'
        + '23 Planning, organizing and sustainability in events<br>'
        + '24 Sustainable planning<br>'
        + '25 Quality of urban life<br>'
        + '26 Socioeconomic issues<br>'
        + '27 Artificial neural networks<br>'
        + '28 Urban environmental rehabilitation<br>'
        + '29 Environmental simulations<br>'
        + '30 Decision support systems<br>'
        + '31 Planning support systems<br>'
        + '32 Emergency and security systems in urban environment<br>'
        + '33 Information systems<br>'
        + '34 Geographic information systems<br>'
        + '35 Global positioning systems<br>'
        + '36 Transport Sustainability<br>'
        + '37 Tourism an urban space<br>'
        + '38 Urban and regional effects and public policies arising from COVID-19<br>',
      },
      {
        text: '<b>NEW CALL FOR PAPERS</b><br><br>'
        + 'Only to the theme: <b>"Urban and regional effects and public'
        + ' policies arising from COVID-19"</b>.<br><br>'
        + 'Abstracts must be submitted by <b>June 1, 2020.</b><br><br>'
        + 'Abstracts should have a length of 300 to 500 words and describe clearly the nature,'
        + ' relevance and objectives of the work, methodology, model or technique used and the results.<br><br>'
        + 'The form for submission of abstracts is available at: <u><a target="_blank" href="http://www.civil.uminho.pt/planning/pluris2020/subm_resumos/resumos_covid.aspx ">'
        + 'http://www.civil.uminho.pt/planning/pluris2020/subm_resumos/resumos_covid.aspx</a></u><br><br>',
      },
      {
        text: 'The list of accepted abstracts is available on the link: <br>'
        + '<u><a target="_blank" href="http://civil.uminho.pt/planning/pluris2020/lista_de_resumos_aprovados_2020_EN.pdf">'
        + ' http://civil.uminho.pt/planning/pluris2020/lista_de_resumos_aprovados_2020_EN.pdf</a></u><br><br>'
        + '<b>The list of accepted abstracts related to the new call for papers "Urban and'
        + ' regional effects and public policies arising from COVID-19" is available on the'
        + ' link:</b>'
        + '<u><a target="_blank" href="http://www.civil.uminho.pt/planning/pluris2020/Lista_de_resumos_covid_aprovados_2020_EN.pdf">'
        + ' http://www.civil.uminho.pt/planning/pluris2020/Lista_de_resumos_covid_aprovados_2020_EN.pdf</a></u><br><br>'
        + '"Any questions regarding the approval of abstracts and papers should be directed to'
        + ' the specific e-mail of the permanent scientific coordination:'
        + ' <u><a>pluriscientifico@gmail.com</a></u>"<br><br>'
        + 'Full conference paper must be sent by <b>September 8, 2020.</b>'
        + ' See template for paper format in the "Papers Submission" tab.',
      },
      {
        text: 'Authors of the abstracts that have been accepted to the next phase of the'
        + ' evaluation process are now invited to submit a full conference paper.<br><br>'
        + 'It is emphasized that only papers accepted in this second phase of the'
        + ' evaluation process will be considered for the event.<br><br>'
        + 'The deadline for submission of full conference papers for evaluation will be '
        + '<b>September 8th, 2020</b>.<br><br>'
        + ' All authors should follow the guidelines defined in the instructions available in'
        + ' the following files: <br><br>'
        + '<strike>in PDF file format (new)</strike><br>'
        + '<strike>in Word file format (new)</strike><br><br>'
        + 'Full conference papers are limited to 12 pages, including figures, tables, and'
        + ' references, as defined in the instructions for authors.<br><br>'
        + 'Papers with more than 12 pages will not proceed in the evaluation process,'
        + ' references, as defined in the instructions for authors.'
        + 'Link to submission of full papers:<br><br>'
        + '<strike>Form for submission of Full Paper</strike>',
      },
      {
        text: 'The list of accepted of full paper is available on the link:<br>'
        + '<a href="http://www.civil.uminho.pt/planning/pluris2020/Lista_de_artigos_aprovados_2021.pdf" target="_blank">http://www.civil.uminho.pt/planning/pluris2020/Lista_de_artigos_aprovados_2021.pdf</a>'
        + '<br><br><b>"Any questions regarding the approval of full papers should be directed to the specific'
        + ' email of the permanent scientific coordination: '
        + '<a href="#">pluriscientifico@gmail.com</a>"</b><br><br>'
        + 'Full conference papers must be sent by <b>December 10, 2020.</b>'
        + ' Review the template for formatting papers in the "<b>Papers Submission</b>" tab.<br><br>'
        + '<b>WARNING:</b> Only the accepted papers (oral or poster) with authors registered in the event will'
        + ' be published in the proceedings of PLURIS 2021.<br><br>'
        + 'Authors registered in the <b>professional category</b> can register up to <b>two papers.</b><br><br>'
        + 'Authors registered in the <b>student category </b>(undergraduate or graduate) can register'
        + ' <b>one paper.</b><br><br>'
        + '<b>Authors who have approved more papers:</b><br><br>'
        + 'For authors registered in the professional category with more than two accepted papers or'
        + ' authors registered in the student category (postgraduate or graduation student) with more than one accepted paper: <b>one of'
        + ' the coauthors should be registered to ensure the publication in the conference proceedings. </b><br><br>'
        + 'It is not guaranteed the publication of articles for registrations made after <b>January 29, 2021</b>.',
      },
      {
        text: '<b>Normas para apresentação assíncrona e síncrona</b>'
        + '<br><br>Disponibilizamos, de forma sugestiva, o modelo para formatação das lâminas'
        + ' (slides) dos trabalhos aprovados no 9º Congresso Luso Brasileiro para o'
        + ' Planejamento Urbano, Regional, Integrado e Sustentável – PLURIS 2021'
        + ' DIGITAL para apresentações assíncrona e síncrona.<br><br>'
        + 'Modelo apresentação - <a href="/template_pluris.pptx" download>'
        + 'Clique aqui.</a>',
      },
    ],
    items4: [
      {
        text: 'Values of Individual Registration (reais).',
        titleH1: '<b>Until January 29, <br> 2021</b>',
        titleH2: '<b>After January 29, <br> 2021 or at the <br> conference</b>',
        titleV1: '<b>Professional<br></b> (can register 2 papers)',
        titleV2: '<b>Postgraduate Student<br></b> (can register 1 paper)',
        titleV3: '<b>Graduation Student <br></b> (can register 1 paper)',
        information: '<br><br><b>INFORMATIONS:</b><br><br>'
        + 'Students must prove their status with valid document issued by the respective colleges '
        + 'or universities.<br><br>',
        subscribe: 'REGISTER HERE',
      },
    ],
    items5: [
      {
        text: '<b>October 31, 2019</b> | 1st call for papers.<br><br>'
        + ' <b>November 25, 2019</b> | 2nd call for papers.<br><br>'
        + ' <b>January 20, 2020</b> | 3rd call for papers.<br><br>'
        + ' <b>February 17, 2020</b> | Deadline for the submission of abstracts.<br><br>'
        + ' <b>March 23, 2020</b> | Notification of acceptance or rejection of abstracts.<br><br>'
        + ' <b>May 08, 2020</b> | Deadline for the submission of full papers.<br><br>'
        + ' <b>June 15, 2020</b> | Notification of acceptance or rejection of full papers.<br><br>'
        + ' <b>August 03, 2020</b> | Deadline for the submission of the final version of full papers.<br><br>'
        + ' <b>August 10, 2020</b> | Deadline for the registration of at least one author and deadline for the registration of all participants benefiting from a discount rate.<br><br>'
        + ' <b>October 07 to 09, 2020 | PLURIS 2020 at the Monte Real Hotel in Águas de Lindóia - São Paulo - Brazil.<br><br> </b>',
        date1: 'October 31, 2019',
        date2: 'November 25, 2019',
        date3: 'January 20, 2020',
        date4: '<span style="color: #939598"><strike>February 17, 2020</strike></span><br>February 28, 2020',
        date5: 'March 23, 2020',
        date6: '<span style="color: #939598"><strike>May 08, 2020</strike></span>'
        + '<br>September 08, 2020',
        date7: '<span style="color: #939598"><strike>June 15, 2020</strike></span>'
        + '<br><b>October 31, 2020</b>',
        date8: '<span style="color: #939598"><strike>August 03, 2020</strike></span>'
        + '<br>December 10, 2020',
        date9: '<span style="color: #939598"><strike>August 10, 2020</strike></span>'
        + '<br>January 29, 2021',
        date10: '<span style="color: #939598"><b><strike>October 07 to 09, 2020</b></strike></span>'
        + '<br><b>April 07 to 09, 2021</b>',
        title1: ' 1st call for papers.',
        title2: ' 2nd call for papers.',
        title3: ' 3rd call for papers.',
        title4: ' Deadline for the submission of abstracts.',
        title5: ' Notification of acceptance or rejection of abstracts.',
        title6: ' Deadline for the submission of full papers.',
        title7: ' <b>Notification of acceptance or rejection of full papers.</b>',
        title8: ' Deadline for the submission of the final version of full papers.',
        title9: ' Deadline for the registration of at least one author and deadline for the registration of all participants benefiting from a discount rate.',
        title10: '<b> PLURIS 2021 <strike>at the Monte Real Hotel in Águas de Lindóia - São Paulo - Brazil.</strike>'
        + ' <span style="color: #0189d0">Digital</span>.</b>',
        dateX1: 'June 01, 2020',
        dateX2: 'June 22, 2020',
        titleX1: 'Deadline for the submission of abstracts.',
        titleX2: 'Notification of acceptance or rejection of abstracts.',
        titleNewCall: '<br><b>NEW CALL FOR PAPERS</b>',
      },
    ],
    items6: [
      {
        date1: 'October 31, 2019',
        title1: 'First call to abstract submission.',
        link1: '',
        date2: 'November 25, 2019',
        title2: 'Second call to abstract submission.',
        link2: '',
        date3: 'January 20, 2020',
        title3: 'Third call to abstract submission.',
        link3: '',
        date4: 'February 14, 2020',
        title4: 'New deadline for the submission of abstracts: ',
        link4: '',
        extension4: 'February 28, 2020',
        date5: 'March 23, 2020',
        link5: '',
        title5: 'Notification of acceptance or rejection of abstracts. ',
        date6: 'March 27, 2020',
        link6: 'Access here.',
        coord6: [3, 3],
        title6: 'The template for the Submission of full papers is available in Submission > Papers Submission:',
        date7: 'April 07, 2020',
        link7: 'Access here.',
        coord7: [3, 3],
        title7: 'The link for the Submission of full papers is available in Submission > Papers Submission:',
        date8: 'May 04, 2020',
        link8: '',
        title8: 'Due to the pandemic caused by COVID-19, associated with the'
        + ' current uncertainty related to the period when the situation will be mitigated,'
        + ' the PLURIS 2020 organizing committee decided to change the conference dates'
        + ' to April 7-9, 2021. Thus, we intend to follow the guidelines of the World Health'
        + ' Organization, in order to reduce the risks associated with the crowding of'
        + ' people.',
        date9: 'May 04, 2020',
        link9: 'Access here.',
        coord9: [5, 0],
        title9: 'New dates for PLURIS 2021.',
        date10: 'May 04, 2020',
        link10: 'Access here.',
        coord10: [3, 1],
        title10: 'New call for papers, only to the topic'
        + ' "Urban and regional effects and public policies arising from COVID-19".',
        date11: 'May 04, 2020',
        link11: 'Access here.',
        coord11: [3, 3],
        title11: 'The new template is available in Submissions> Papers Submission.',
        date12: 'June 22, 2020',
        link12: 'Access here.',
        coord12: [3, 2],
        title12: 'Notification of acceptance or rejection of abstracts.',
        date13: 'September 30, 2020',
        link13: '',
        title13: 'We inform that the notification of the review results of full papers submitted'
        + ' to PLURIS 2021 has been extended to October 31, 2020.',
        date14: 'October 31, 2020',
        link14: 'Access here.',
        coord14: [3, 4],
        title14: 'Notification of acceptance or rejection of full papers.',
        date15: 'October 31, 2020',
        link15: '',
        title15: 'Due to the continuing uncertainty regarding the COVID-19 pandemic, the PLURIS'
        + ' 2021 organizing committee decided to change the congress to digital format. New'
        + ' registration fees will be announced, as well as a new event program will be drawn up,'
        + ' but the dates remain unchanged (April 7-9, 2021).',
        date16: 'November 12, 2020',
        link16: '',
        title16: 'Authors should update the article template for the new version, as the'
        + ' header has been changed.'
        + '<a href="/template_pluris_en.docx" download>Access here.</a>'
        + ' The submission of final papers must be done through the individual link'
        + '  that the scientific committee sent to each author by email.',
        date17: 'November 27, 2020',
        link17: 'Access here.',
        coord17: [4, 0],
        title17: 'Registrations for PLURIS 2021 Digital are open!',
        date18: 'March 04, 2021',
        link18: 'Access here.',
        coord18: [3, 5],
        title18: 'To obtain the presentation formatting template: ',
        date19: 'March 05, 2021',
        link19: '',
        title19: 'Saiba como será o PLURIS 2021 totalmente digital! ',
        date20: 'March 08, 2021',
        link20: '',
        title20: 'O PLURIS 2021 DIGITAL está chegando e, com ele, muitas'
        + ' novidades! Saiba como será a programação científica do evento!',
        date21: 'March 09, 2021',
        link21: 'Access here.',
        coord21: [3, 5],
        title21: 'Envie a apresentação do seu trabalho. Saiba mais!  ',
        date22: 'March 18, 2021',
        link22: '',
        title22: 'Nota de Falecimento Profa Júlia Lourenço',
        date23: 'March 25, 2021',
        link23: 'Access here.',
        coord23: [1, 2],
        title23: 'Programação final.  ',
        date24: 'April 05, 2021',
        link24: 'Access here.',
        coord24: [1, 5],
        title24: 'Confira a Versão Preliminar dos Anais do PLURIS 2021.',
        date25: '06/04/2021',
        link25: '',
        title25: 'Confira a Programação Final dos Painéis Temáticos.</b> <a href="/programacao_paineis.pdf" download>Clique aqui.</a>',
        date26: '06/04/2021',
        link26: '',
        title26: 'PARA TER ACESSO À PLATAFORMA VIRTUAL DO PLURIS 2021,'
        + '<a href="https://plurisdigital.ciente.live/login/"'
        + ' target="_blank">CLIQUE AQUI.</a>',
        date27: '12/05/2021',
        link27: 'clique aqui.',
        coord27: [1, 6],
        title27: 'Para acessar os certificados do PLURIS 2021, ',
        date28: '<b>21/05/2021</b>',
        link28: 'clique aqui.',
        coord28: [1, 5],
        title28: '<b>Para acessar a versão definitiva dos Anais do PLURIS 2021, </b>',
      },
    ],
  },
};
